import React from "react"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"

const Footer = () => {
  return (
    <footer className="py-5">
      <Container className="mb-3">
        <Row className="text-center text-sm-left">
          <Col sm={3} className="mb-3 mb-sm-0">
            <div className="overline mb-1">Artist Network</div>
            <ul className="list-unstyled">
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/search"
                >
                  Search
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/artists"
                >
                  Artists
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/collections/all-artworks"
                >
                  Artworks
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/services"
                >
                  Services
                </a>
              </li>
            </ul>
          </Col>
          <Col sm={3} className="mb-3 mb-sm-0">
            <div className="overline mb-1">Content</div>
            <ul className="list-unstyled">
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/special-projects"
                >
                  Special Projects
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/blogs/blog"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/videos"
                >
                  Videos
                </a>
              </li>
            </ul>
          </Col>
          <Col sm={3} className="mb-3 mb-sm-0">
            <div className="overline mb-1">Hua</div>
            <ul className="list-unstyled">
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/about"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/contact-us"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/press"
                >
                  Press
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/careers"
                >
                  Careers
                </a>
              </li>
            </ul>
          </Col>
          <Col sm={3} className="mb-3 mb-sm-0">
            <div className="overline mb-1">Connect</div>
            <ul className="list-unstyled">
              <li>
                <a
                  className="text-decoration-none"
                  href="https://hua-gallery.com/pages/newsletter"
                >
                  Newsletter
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://www.instagram.com/hua.arte/"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://www.pinterest.co.uk/huaarte/"
                >
                  Pinterest
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://www.facebook.com/Hua-Gallery-164816493573902/"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  className="text-decoration-none"
                  href="https://twitter.com/hua_arte"
                >
                  Twitter
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
      <Container className="text-center text-sm-left">
        <div style={{ fontWeight: 400, fontSize: "2rem" }} className="mb-2">
          H U A
        </div>
        <div>© 2011–{new Date().getFullYear()} Hua Art Ltd</div>
      </Container>
    </footer>
  )
}

export default Footer
